import has from 'lodash/has';
import set from 'lodash/set';
import unset from 'lodash/unset';

import { log, warn } from 'utils/console';

/**
 * Exposer
 * =======
 *
 * Puts any object onto the window for use in the global scope
 *
 * @param {Object} list - `{ 'namespace.on.window' : someObject }`
 * @param {Window} [_window] - for mocking
 */
export default function exposer(list, _window = window) {
    const keys = Object.keys(list);
    log('exposer', keys.join(', '));

    keys.forEach((key) => {
        const val = list[key];
        if (has(_window, key)) {
            warn(`"${key}" already exists`);
            return;
            // @TODO: Do we want to fail hard?
            // throw new Error(`"${key}" already exists`);
        }
        set(_window, key, val);
    });
}

export const expose = exposer;

/**
 * @param {string[]} keys
 * @param {Window} [_window] - for mocking
 */
export function unexpose(keys, _window = window) {
    log('exposer', 'unexpose', keys.join(', '));
    keys.forEach((key) => {
        if (has(_window, key)) {
            unset(_window, key);
        } else {
            warn(`"${key}" wasn't previously exposed`);
        }
    });
}
